<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="component-chat-log" class="m-8 vs-con-loading__container" ref="chat_log">
    <div
      v-for="(chat, index) in chatData.filter(item => item.id == userId)"
      class="msg-grp-container"
      :key="index"
    >
      <!-- If previouse msg is older than current time -->
      <template v-if="chatData[index - 1]">
        <vs-divider v-if="!isSameDay(chat.msg.time, chatData[index - 1].msg.time)">
          <span>{{ toDate(chat.msg.time) }}</span>
        </vs-divider>
        <div
          class="spacer mt-8"
          v-if="!hasSentPreviousMsg(chatData[index - 1].msg.senderId, chat.msg.senderId)"
        ></div>
      </template>

      <template v-else>
        <vs-divider v-if="isSameDay(chat.msg.time, chatData[index].msg.time)">
          <span>{{ toDate(chat.msg.time) }}</span>
        </vs-divider>
        <div
          class="spacer mt-8"
          v-if="!hasSentPreviousMsg(chatData[index].msg.senderId, chat.msg.senderId)"
        ></div>
      </template>

      <div
        class="flex items-start"
        :class="[{ 'flex-row-reverse': chat.msg.isSent }]"
      >
        <template v-if="chatData[index - 1]">
          <template
            v-if="
              !hasSentPreviousMsg(chatData[index - 1].msg.senderId, chat.msg.senderId) ||
              !isSameDay(chat.msg.time, chatData[index - 1].msg.time)
            "
          >
            <vs-avatar
              size="40px"
              class="m-0 flex-no-shrink cursor-default"
              :class="chat.msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
              :src="senderImg(chat.msg.isSent)"
            ></vs-avatar>
          </template>
        </template>

        <template v-if="index == 0">
          <vs-avatar
            size="40px"
            class="m-0 flex-no-shrink cursor-default"
            :class="chat.msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
            :src="senderImg(chat.msg.isSent)"
          ></vs-avatar>
        </template>

        <template v-if="chatData[index - 1]">
          <div
            class="mr-16"
            v-if="
              !(
                !hasSentPreviousMsg(
                  chatData[index - 1].msg.senderId,
                  chat.msg.senderId
                ) || !isSameDay(chat.msg.time, chatData[index - 1].msg.time)
              )
            "
          ></div>
        </template>

        <div
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
          :class="{
            'bg-primary-gradient text-white': chat.msg.isSent,
            'border border-solid border-grey-light bg-white': !chat.msg.isSent,
          }"
        >
          <p><strong><small>{{chat.msg.sender}}</small></strong></p>
          <span>{{ chat.msg.textContent }}</span>

          <div class="relative mt-2">
            <p class="absolute" style="right: -9px;top: -8px;font-size: 10px;color: #bbb !important;"><small>{{ sentTime(chat.msg.time) }}</small></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contacts from "./contacts";

export default {
  props: {
    userId: {
      type: Number,
      required: true,
    },
    chatData: {}
  },
  data() {
    return {
      contacts: contacts,
    };
  },
  computed: {
    // chatData() {
    //   return this.$store.getters["chat/chatDataOfUser"](this.userId);
    // },
    contactIndex() {
      return contacts.findIndex((contact) => contact.id == this.userId);
    },
    userImg() {
      if (this.contactIndex !== -1) return this.contacts[this.contactIndex].img;
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.img;
    },
    senderImg() {
      return (isSentByActiveUser) => {
        // if (isSentByActiveUser)
        //   return JSON.parse(localStorage.getItem('userInfo')).profilePictureUrl;
        // else
        //   return require(`@/assets/images/portrait/small/${
        //     this.contacts[this.contactIndex].img
        //   }`);
        null
      };
    },
    hasSentPreviousMsg() {
      return (last_sender, current_sender) => last_sender == current_sender;
    },
  },
  methods: {
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to));
      const date_time_from = new Date(Date.parse(time_from));
      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      );
    },
    toDate(time) {
      const locale = "en-za";
      const date_obj = new Date(Date.parse(time));
      const monthName = date_obj.toLocaleString(locale, {
        month: "short",
      });

      var today_date_obj = new Date();
      var current_monthName = today_date_obj.toLocaleString(locale, {
        month: "short"
      });

      var today_date_string = today_date_obj.getDate() + " " + current_monthName;

      return date_obj.getDate() + " " + monthName == today_date_string ? "Today" : date_obj.getDate() + " " + monthName;
    },
    sentTime(fullDate) {
      var date_obj = new Date(Date.parse(fullDate));
      var hours = date_obj.getHours();
      var mins = date_obj.getMinutes();

      if (hours < 10)
        hours = `0${hours}`;

      if (mins < 10)
        mins = `0${mins}`;

      return `${hours}:${mins}`
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight;
      });
    },
  },
  updated() {
    this.scrollToBottom();
  },
  mounted() {
    this.scrollToBottom();
  },
};
</script>
